import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { ReplaySubject } from 'rxjs';

/**
 * Manage PWA state i.e. updates to the service worker.. and install action
 * @export
 * @class PwaService
 */
@Injectable({
  providedIn: 'root',
})
export class PwaService {
  installPrompt: any;
  updateAvailable: boolean = false;
  public updateAvailable$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(private swUpdate: SwUpdate) {
    // install app handler
    window.addEventListener('beforeinstallprompt', (event) => {
      this.installPrompt = event;
    });

    // service worker update subscription
    console.log("PWAService constructor, registering for versionUpdates")
    this.swUpdate.versionUpdates.subscribe((event) => {
      console.log("update.component.swUpdate.versionUpdates.subscribe: event" , event);
      if ( event && event.type == 'VERSION_READY' )
      {
        console.log("This is a new version that is ready to be installed");
        this.updateAvailable = true;
        this.updateAvailable$.next(true);
      }
    });

  }

  isUpdateAvailable()
  {
    return this.updateAvailable;
  }

  /* istanbul ignore next */ 
  // not sure how this is used so will not write a test for now.
  installPwa(): void {
    try {
      this.installPrompt.prompt();
    } catch (error) {
      console.error(error);
    }
  }

  async checkForUpdate() {
    console.log("Request to register for updates, can we? ", this.swUpdate.isEnabled)
     if ( this.swUpdate.isEnabled ) 
     {
        console.log('***[Accounts app] checkForUpdate started');
        try {
          await this.swUpdate.checkForUpdate();
          console.log('[Accounts app] checkForUpdate completed');
        } catch (error) {
          console.error(error);
        }
      }
  }

  /* istanbul ignore next */ 
  // not sure how this is used so will not write a test for now.
  activateUpdate() {
    console.log('[Accounts app] activateUpdate started');
    this.swUpdate
      .activateUpdate()
      .then(() => {
        console.log('[Accounts app] activateUpdate completed');
        window.location.reload();
      })
      .catch((err) => {
        console.error(err);
      });
  }
}
